import React, { useEffect, useState, useRef } from 'react'

import { ScrollView, View, StyleSheet, Keyboard, TouchableOpacity, Text, Platform, ActivityIndicator } from 'react-native'
import delay from 'delay'

import { useFormik } from 'formik'
import * as Yup from 'yup'

import {
  Description,
  Space,
  TextInputExtended,
  Select,
  SelectExtended,
  Button,
  Anchor,
  Label,
  KeyboardAvoidingView,
  PaymentHistoryItem
} from '@sart/components'
import { adaptive, backgroundColors, colors, typography } from '@sart/styles'
import client, { orderHelper, useData } from '@sart/client'
import { useContent } from '@sart/content'

import ApiClient from "../bff-client/src/ApiClient";
import CustomersApi from "../bff-client/src/api/CustomersApi";
import AppConfig from '../Configuration/AppConfig';
import account from './account.json'
import * as theme from '../Sign/signTheme'
import { HelpIcon } from '@sart/icons'
import { testID } from '@sart/utilities'
import { set } from 'lodash-es'

export default function PaymentHistory(props) {
  const { navigation } = props
  const [paymentHistoryItems, setPaymentHistoryItems] = useState([])
  const [loading, setLoading] = useState(true)

  const bffClient = new ApiClient(AppConfig.bffBasePath)
  bffClient.defaultHeaders = {
    ...bffClient.defaultHeaders,
    Origin: AppConfig.shopOriginUrl,
    Authorization: client.api.defaultHeaders['Authorization']
  }
  const customersApi = new CustomersApi(bffClient)

  useEffect(() => {
    getPaymentHistory()
  }, [])

  async function getPaymentHistory() {
    setLoading(true)

    try {
      await client.refreshToken();
      const response = await customersApi.customersIdPaymenthistoryGet(client.cache.customerId);
      setPaymentHistoryItems(response);
      console.log("payment history is: " + JSON.stringify(response, null, 2));
    } catch (error) {
      console.error(JSON.stringify(error, null, 2));
    }

    setLoading(false)
  }

  const content = useContent()

  var formik = useFormik({
    initialValues: {
      number: '',
      code: '',
      forename: '',
      middleName: '',
      surname: '',
    },
    validationSchema: Yup.object().shape({
      number: Yup.string().trim().required(content.forms.required).matches(/^((?!(0))[0-9]{10})$/, content.switch_number.numberNotValid),
      code: Yup.string().trim().required(content.forms.required).matches(/^\d{4}$/, content.switch_number.invalidPAC),
      forename: Yup.string().trim().required(content.forms.required),
      middleName: Yup.string().trim(),
      surname: Yup.string().trim().required(content.forms.required),
    }),
    onSubmit: handleSubmit,
  })



  async function handleSubmit(values, form) {
    Keyboard.dismiss()

    form.setSubmitting(true)
    try {

      form.setSubmitting(false)


    } catch (error) {
      // const message = prettyErrorMessage(error)

      // form.setFieldError('gender', message)
      form.setSubmitting(false)
    }
  }


  return (
    // <KeyboardAvoidingView style={styles.container}>
    <ScrollView style={styles.container} contentContainerStyle={styles.contentContainer}
    // ref={scrollViewRef}
    >
      <View style={styles.widthRestrictions}>
        {loading &&
          <ActivityIndicator size="large" color={colors.brightOrange} />
        }
        {(!loading && paymentHistoryItems && paymentHistoryItems.length > 0) && paymentHistoryItems.map((item) =>
          <>
            <PaymentHistoryItem key={item.id} payment={item} />
            <Space height={16} />
          </>
        )}

        {(!loading && (!paymentHistoryItems || paymentHistoryItems.length === 0)) &&

          <Description style={styles.description}>{content.profile_payment.noPayments}</Description>

        }
      </View>
    </ScrollView>
    // </KeyboardAvoidingView>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingTop: 24,
    paddingBottom: 10,
    marginBottom: 10,
    backgroundColor: backgroundColors.darkCharcoal,
    ...adaptive.wrapperPadding,
    width: '100%',
  },
  contentContainer: {
    ...Platform.select({
      web: {
        alignItems: 'center'
      }
    })
  },
  description: {
    textAlign: 'center',
    ...typography.lightbold,
    color: colors.brightOrange
  },
  selectStyle: {
    ...typography.demi
  },
  curpFooter: {
    ...typography.demi,
    color: colors.brightOrange,
    alignContent: 'flex-end',
    textDecorationLine: 'underline'
  },
  inputWrapper: {
    flexDirection: 'row',
  },
  nestedInputs: {
    flex: 1
  },
  inputStyle: {
    height: 300
  },
  enabledButton: {
    backgroundColor: colors.brightOrange,
  },
  disabledButton: {
    backgroundColor: colors.brightOrange + 50
  },
  label: {
    color: colors.brightOrange,
    ...typography.lightbold,
    fontSize: 16
  },
  helpIcon: {
    justifyContent: 'center'
  },
  helpPointContainer: {
  },
  helpPointText: {
    ...typography.medium,
    color: colors.brightOrange,
    fontSize: 14
  },
  noId: {
    ...typography.demi,
  },
  labelStyles: {
    color: colors.brightOrange,
    ...typography.demi
  },
  enabled: {
    backgroundColor: colors.brightOrange
  },
  disabled: {
    backgroundColor: colors.brightOrange + 60,
    borderColor: colors.brightOrange + 60,
    borderWidth: 1
  },
  widthRestrictions: {
    width: '100%',
    maxWidth: 600,
    paddingBottom: 20
  }
})

const selectStyle = {
  control: (base) => ({
    ...base,
    ...typography.demi,
  }),
  menu: (base) => ({
    ...base,
    ...typography.demi
  })
};